import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/copy';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="2lp53mmtzyurk">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="26xmu97vn7yh6">
        <header className="text-center" data-id="element-86" data-mp="26wldqnvuyjs2">
          <h2 className="font-display text-2xl font-bold sm:text-4xl" data-id="element-87" data-mp="2bwhac22878xl">
            ¿Cuánto más vas a vivir saturada?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88" data-mp="1xwga8otsc5j6">
            Sos una madre que lo da todo. Pero recibís tanta información sobre la epilepsia de tu
            hijo que terminás con:
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-89" data-mp="1syn4ty0b3fjy">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-90" data-mp="1t0r5m72wryg0" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-91" data-mp="1tzhjoow7uo81" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-92" data-mp="27v338gjokft2">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-93" data-mp="1g1j63lppyvtl">
          ¿Y si en 14 días pudieras tener todo bajo control?
        </p>
      </div>
    </section>;
}